import { useNavigate } from "react-router-dom";
import { selectAtom } from "jotai/utils";
import { coreAtom } from "@/core/state/root";
import { useAtom } from "jotai";
import { DashboardRoutes } from "@/router";

type fallbackFunc = () => void;
type optionsArgs = Partial<{
  fallback: string | fallbackFunc;
}>;
const lastVisitedUrlThatWasAPageAtom = selectAtom(coreAtom, (val) => val.lastVisitedUrlThatWasAPage);
export const useLastUrlWasPage = () => {
  const [lastVisitedUrlThatWasAPage] = useAtom(lastVisitedUrlThatWasAPageAtom);
  const domNavigate = useNavigate();

  return {
    last: lastVisitedUrlThatWasAPage,
    navigateToLast: (args?: optionsArgs) => {
      if (lastVisitedUrlThatWasAPage) {
        domNavigate(lastVisitedUrlThatWasAPage);
      } else if (args?.fallback && typeof args.fallback === "string") {
        window.location.href = args.fallback;
      } else if (args?.fallback && typeof args.fallback === "function") {
        args.fallback();
      } else {
        domNavigate(DashboardRoutes.home.overview.url);
      }
    },
  };
};
